<script>
		import {user, view} from "../client.svelte.js";
		import {notEmpty, token_URL} from "../core.js";
		import Input from "../elements/Input.svelte";
		import Sidebar from "../elements/Sidebar.svelte";

		let fellowships = $derived(
			Object.fromEntries(
				user.fellowships.values()
					.map(fshp => [fshp.ID, {
						fellowship: fshp.name,
						whereabout: fshp.whereabout,
						gamesCount:  user.tales.values().filter(tale => tale.fellowship === fshp.ID).toArray().length}]) ) )
		let heroes = $derived(
      user.characters.values()
        .filter(char => char.ZUB === 'Hero' && (char.owner === user.ID || user.isMaster))
				.map(char => Object.assign(char, fellowships[char.fshipID]))
        .toArray() )

		// $inspect(`HEROES - heroes`, heroes)

		async function select_hero(e) {
				// console.log(`HEROES - Hero ${this.name} selected`, this)
				if (this.ID) {
						await view.select_character(this.ID)
						view.switch_layout('hero-descript')
				} else
					view.switch_layout('hero-create')
		}

</script>


<!-------------------------------- HTML -------------------------------------->

<section id='hero-catalog'>

	<Sidebar/>

	<header>
		<h1>Deine Helden</h1>
	</header>

	<article>
		<div class="heroes-box">
			{#each heroes as hero}
				{@render HeroCard(hero)}
			{/each}
			{@render HeroCard({tokenURL: "/assets/PUBLIC/tokens/default.png"})}
		</div>
	</article>
</section>


{#snippet HeroCard(hero)}
	<div class="hero-card" onclick={select_hero.bind(hero)} >
    <figure id='portrait' class="portrait" >
      <img src={hero.tokenURL} alt="Token cannot be found" title={hero.ID}/>
    </figure>
    <Input field=name value={hero.name} style="font-size: large; font-weight: bold"  onclick={select_hero.bind(hero)} disabled />
    <Input field=vocation value={hero.vocation} disabled />
    <Input field=level value={hero.level} type=number disabled style="justify-self: end; align-self: center;"/>
    <Input field=race value={hero.race} disabled />
    <Input field=origin value={hero.origin} disabled />
    <Input field=age value={hero.age} type=number style="justify-self: center;" disabled />
		<Input field=fellowship value={hero.fellowship} disabled />
		<Input field=whereabout value={hero.whereabout} disabled />
		<Input field=games value={hero.gamesCount} type=number disabled />
	</div>

{/snippet}


<!-------------------------------- STYLE -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	h1
		margin-left: 32px

	.heroes-box
		display: flex
		flex-wrap: wrap
		padding: 32px
		gap: 16px
		justify-content: space-evenly

	// Hero Card
	.hero-card
		display: grid
		grid-template-columns: 140px repeat(2, minmax(128px, 256px)) 8ch
		padding: 16px
		gap: 8px
		background-color: colors.$grey-20

	figure
		display: inline-block
		margin: 16px

	figcaption
		text-align: center

	.portrait
		grid-area: 1 / 1 / span 3
		align-self: end
		justify-self: end
		margin: 0

	.portrait img
		width: 128px
		height: 128px
		margin: 12px

	button
		display: inline-block

	button.terminate
		float: right
</style>